import { render } from "./viewClient.html?vue&type=template&id=4a9e68a8&scoped=true&ts=true&external"
import script from "./ViewClient.vue?vue&type=script&lang=ts"
export * from "./ViewClient.vue?vue&type=script&lang=ts"

import "./ViewClient.vue?vue&type=style&index=0&id=4a9e68a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e68a8"]])

export default __exports__